<template>
    <el-dialog
        :title="title"
        class="leader-dialog"
        :visible.sync="btnVsb"
        :close-on-click-modal="false"
        @close="closeCb"
    >
        <el-form
            label-width="150px"
            :model="btnForm"
            :rules="btnRules"
            ref="btnForm"
            class="leader-style-form"
        >
            <el-form-item label="按钮名称" prop="button_name">
                <el-input
                    maxlength="50"
                    v-model="btnForm.button_name"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
            <el-form-item label="按钮id" prop="button_key">
                <el-input
                    :disabled="title == '修改按钮'"
                    maxlength="100"
                    v-model="btnForm.button_key"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button
                @click="btnVsb = false"
                class="leader-common-button"
                size="small"
                >取 消</el-button
            >
            <el-button
                type="primary"
                @click="addCommit"
                size="small"
                class="leader-common-button"
                >确 定</el-button
            >
        </div>
    </el-dialog>
</template>
<script>
import * as api from "@/http/api";
export default {
    props: {
        btnVsb: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "新增按钮"
        },
        menuId: String,
        btnId: String
    },
    data() {
        return {
            btnForm: {
                button_name: "",
                button_key: ""
            },
            btnRules: {
                button_name: [
                    {
                        required: true,
                        message: "请填写按钮名称",
                        trigger: "blur"
                    }
                ],
                button_key: [
                    {
                        required: true,
                        message: "请填写按钮id",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {
        btnVsb(newVal) {
            if (newVal && this.btnId) {
                this.getButtonInfoById();
            }
        }
    },
    methods: {
        getButtonInfoById() {
            api.getButtonInfoById({
                button_id: this.btnId
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.btnForm.button_name = res.bus_json.button_name;
                    this.btnForm.button_key = res.bus_json.button_key;
                }
            });
        },
        closeCb() {
            this.btnVsb = false;
            this.$refs.btnForm.resetFields();
            this.$emit("update:btnVsb", this.btnVsb);
            this.$emit("closeCb");
        },
        addCommit() {
            this.$refs["btnForm"].validate(valid => {
                if (valid) {
                    api.saveButton({
                        ...this.btnForm,
                        menu_id: this.menuId,
                        button_id: this.btnId
                    }).then(res => {
                        if (res && res.error_code == 0) {
                            this.$message({
                                message: res.error_msg,
                                type: "success"
                            });
                            this.closeCb();
                        }
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss"></style>
